const SummaryCard = ({ title, value, subtitle, icon: Icon, colorClass, bgColor, pulse }) => (
  <div 
    data-testid={`summary-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    className={`relative overflow-hidden backdrop-blur-sm bg-slate-800/80 border border-slate-700 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 p-5 animate-fade-in group hover:-translate-y-1 ${
      pulse ? 'ring-2 ring-offset-2 ring-offset-slate-900 ' + (colorClass?.includes('red') ? 'ring-red-500/50' : 'ring-amber-500/50') : ''
    }`}
  >
    {/* Decorative gradient blob */}
    <div className={`absolute -top-10 -right-10 w-32 h-32 rounded-full opacity-20 blur-2xl transition-opacity duration-300 group-hover:opacity-30 ${bgColor || 'bg-slate-400'}`}></div>
    
    <div className="relative flex items-start justify-between">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide mb-1 text-slate-400">{title}</p>
        <p className={`text-4xl font-bold tabular-nums ${colorClass || 'text-white'}`}>{value}</p>
        {subtitle && <p className="text-xs mt-2 text-slate-500">{subtitle}</p>}
      </div>
      {Icon && (
        <div className={`p-3 rounded-xl transition-transform duration-300 group-hover:scale-110 ${bgColor || 'bg-slate-700'}`}>
          <Icon className={`w-6 h-6 ${colorClass || 'text-slate-400'}`} />
        </div>
      )}
    </div>
  </div>
);

export default SummaryCard;
